module.exports = __webpack_public_path__ + "static/img/145.a920b71c.png";